module.exports = __webpack_public_path__ + "0643b846ff11fd9c874a1acd53228e12.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1158
// module chunks = 0